/**
 * Parfum Account Drawer Component
 * Handles the opening and closing of the bespoke account drawer.
 */

class ParfumAccountDrawer extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.closeButton = this.querySelector('[data-close-drawer]');
    
    // Bind events
    this.closeButton?.addEventListener('click', () => this.close());
    
    // External trigger events
    document.addEventListener('parfum-account-drawer:open', () => this.open());
    
    // Close on click outside
    this.dialog?.addEventListener('click', (event) => {
      if (event.target === this.dialog) {
        this.close();
      }
    });

    // Password toggle
    this.querySelector('.parfum-account-drawer__password-toggle')?.addEventListener('click', (e) => {
      const input = this.querySelector('#CustomerPassword');
      const type = input.getAttribute('type') === 'password' ? 'text' : 'password';
      input.setAttribute('type', type);
    });
  }

  open() {
    this.dialog?.showModal();
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.dialog?.close();
    document.body.classList.remove('overflow-hidden');
  }
}

customElements.define('parfum-account-drawer', ParfumAccountDrawer);
